<!-- <p>incident-details-dialog works!</p> -->
<mat-dialog-content>
  <div
    [ngClass]="{
      'visitor-detail-wrapper':
        screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
      'visitor-detail-wrapper-mobile': screenSize == ScreenType.Mobile
    }"
  >
    <mat-card class="visitor-detail-card">
      <mat-card-header class="visitor-detail-card-header">
        {{ "Incident Details" | uppercase }}
        <button mat-mini-fab mat-dialog-close>
          <mat-icon>clear</mat-icon>
        </button>
      </mat-card-header>
      <mat-card-content class="visitor-detail-card-content">
        <form [formGroup]="showIncidentDetailsForm">
          <mat-grid-list
            [cols]="screenSize == ScreenType.Mobile ? 1 : 2"
            [rowHeight]="screenSize == ScreenType.Mobile ? '120px' : '90px'"
            [gutterSize]="'10px'"
          >
            <mat-grid-tile
              [rowspan]="
                screenSize == ScreenType.Mobile && isPopDetails
                  ? 8
                  : screenSize == ScreenType.Mobile && !isPopDetails
                  ? 10
                  : 5
              "
            >
              <div class="internalMatGrid">
                <mat-grid-list
                  [cols]="screenSize == ScreenType.Mobile ? 1 : 2"
                  rowHeight="90px"
                >
                  <mat-grid-tile
                    ><mat-form-field
                      subscriptSizing="dynamic"
                      appearance="outline"
                    >
                      <mat-label>Incident Id</mat-label>
                      <input
                        readonly
                        matInput
                        formControlName="incidentId"
                      /> </mat-form-field
                  ></mat-grid-tile>
                  <mat-grid-tile
                    ><mat-form-field
                      subscriptSizing="dynamic"
                      appearance="outline"
                    >
                      <mat-label>Incident Name</mat-label>
                      <input
                        readonly
                        formControlName="incidentName"
                        matInput
                      /> </mat-form-field
                  ></mat-grid-tile>

                  <mat-grid-tile
                    ><mat-form-field
                      subscriptSizing="dynamic"
                      appearance="outline"
                    >
                      <mat-label>Incident Type</mat-label>
                      <input
                        readonly
                        formControlName="incidentType"
                        matInput
                      /> </mat-form-field
                  ></mat-grid-tile>
                  <mat-grid-tile *ngIf="!isIncidentDescription"
                    ><mat-form-field
                      subscriptSizing="dynamic"
                      appearance="outline"
                    >
                      <input
                        readonly
                        formControlName="incidentLocation"
                        matInput
                      />
                      <mat-label>Incident Location</mat-label>
                    </mat-form-field></mat-grid-tile
                  >
                  <mat-grid-tile *ngIf="isIncidentDescription"
                    ><mat-form-field
                      subscriptSizing="dynamic"
                      appearance="outline"
                    >
                      <input
                        readonly
                        formControlName="incidentDescription"
                        matInput
                      />
                      <mat-label>Incident Description</mat-label>
                    </mat-form-field></mat-grid-tile
                  >
                  <mat-grid-tile
                    ><mat-form-field
                      subscriptSizing="dynamic"
                      appearance="outline"
                    >
                      <mat-label>Source</mat-label>
                      <input
                        readonly
                        matInput
                        formControlName="sourceAsset"
                      /> </mat-form-field
                  ></mat-grid-tile>
                  <mat-grid-tile *ngIf="!isUpdateIncident"
                    ><mat-form-field
                      subscriptSizing="dynamic"
                      appearance="outline"
                    >
                      <mat-label>Incident Status</mat-label>
                      <input
                        readonly
                        matInput
                        formControlName="incidentStatus"
                      /> </mat-form-field
                  ></mat-grid-tile>
                  <mat-grid-tile *ngIf="isUpdateIncident"
                    ><mat-form-field
                      subscriptSizing="dynamic"
                      appearance="outline"
                    >
                      <mat-label>Incident Status</mat-label>

                      <mat-select formControlName="incidentStatus">
                        <mat-option value="0">Open</mat-option>
                        <mat-option value="1">Close</mat-option>
                        <mat-option value="2">Verified</mat-option>
                        <mat-option value="3">Snooze</mat-option>
                        <mat-option value="4">In-progress</mat-option>
                        <mat-option value="5">On-hold</mat-option>
                        <mat-option value="6">Approved</mat-option>
                        <mat-option value="7">Rejected</mat-option>
                      </mat-select>
                    </mat-form-field></mat-grid-tile
                  >
                  <mat-grid-tile
                    ><mat-form-field
                      subscriptSizing="dynamic"
                      appearance="outline"
                    >
                      <mat-label>Incident Priority</mat-label>
                      <input
                        readonly
                        formControlName="incidentCriticality"
                        matInput
                      /> </mat-form-field
                  ></mat-grid-tile>
                  <mat-grid-tile *ngIf="!isUpdateIncident"
                    ><mat-form-field
                      subscriptSizing="dynamic"
                      appearance="outline"
                    >
                      <mat-label>Assignee</mat-label>
                      <input
                        readonly
                        formControlName="assignedTo"
                        matInput
                      /> </mat-form-field
                  ></mat-grid-tile>
                  <mat-grid-tile *ngIf="isUpdateIncident"
                    ><mat-form-field
                      subscriptSizing="dynamic"
                      appearance="outline"
                    >
                      <mat-label>Assign</mat-label>
                      <input
                        matInput
                        [formControl]="hostFilter"
                        [matAutocomplete]="auto"
                      />
                      <mat-autocomplete
                        (optionSelected)="hostSelect($event)"
                        #auto="matAutocomplete"
                      >
                        <mat-option
                          *ngFor="let host of filteredUserList"
                          [value]="host.firstname + ' ' + host.lastname"
                        >
                          {{ host.firstname + " " + host.lastname }}
                        </mat-option>
                      </mat-autocomplete>
                      <!-- <mat-select
                        formControlName="assignedTo"
                        (valueChange)="onChangeAssignee($event)"
                      >
                        <mat-option
                          *ngFor="let user of usersList; let i = index"
                          [value]="user.userId"
                          >{{
                            user.firstname + " " + user.lastname | titlecase
                          }}</mat-option
                        >
                      </mat-select> -->
                    </mat-form-field></mat-grid-tile
                  >
                  <mat-grid-tile *ngIf="isShowReporter"
                    ><mat-form-field
                      subscriptSizing="dynamic"
                      appearance="outline"
                    >
                      <mat-label>Reporter</mat-label>
                      <input
                        readonly
                        formControlName="incidentReporter"
                        matInput
                      /> </mat-form-field
                  ></mat-grid-tile>
                  <mat-grid-tile
                    ><mat-form-field
                      subscriptSizing="dynamic"
                      appearance="outline"
                    >
                      <mat-label>Tag Name</mat-label>
                      <input
                        matInput
                        formControlName="eventOwnerName"
                      /> </mat-form-field
                  ></mat-grid-tile>
                  <mat-grid-tile
                    ><mat-form-field
                      subscriptSizing="dynamic"
                      appearance="outline"
                    >
                      <mat-label>Tag Email</mat-label>
                      <input
                        matInput
                        formControlName="eventOwnerEmail"
                      /> </mat-form-field
                  ></mat-grid-tile>
                  <mat-grid-tile>
                    <mat-form-field
                      appearance="outline"
                      subscriptSizing="dynamic"
                    >
                      <ngx-mat-intl-tel-input
                        #phoneInput
                        [enablePlaceholder]="true"
                        [required]="false"
                        [preferredCountries]="['in']"
                        [enableSearch]="true"
                        name="phone"
                        formControlName="eventOwnerPhone"
                        [inputPlaceholder]="'Phone Number'"
                        [label]="'Phone Number'"
                        [maxlength]="15"
                      ></ngx-mat-intl-tel-input>
                      <mat-error
                        *ngIf="showIncidentDetailsForm.controls['eventOwnerPhone']?.errors?.['validatePhoneNumber']
                    &&
                    false"
                        ><i>Enter valid number</i>
                      </mat-error>
                    </mat-form-field>
                  </mat-grid-tile>
                  <mat-grid-tile *ngIf="!isPopDetails">
                    <div class="button-tile">
                      <button
                        [disabled]="incidentDetail.incidentStatus == 3"
                        (click)="onSnoozeIncident(incidentDetail)"
                        mat-raised-button
                      >
                        {{
                          incidentDetail.incidentStatus == 3
                            ? "Snoozed"
                            : "Snooze"
                        }}
                      </button>
                    </div>
                  </mat-grid-tile>

                  <mat-grid-tile *ngIf="false">
                    <div class="button-tile">
                      <button
                        *ngIf="!isUpdateIncident"
                        (click)="onEdit()"
                        mat-raised-button
                      >
                        Edit
                      </button>
                      <button
                        *ngIf="isUpdateIncident"
                        [disabled]="false"
                        (click)="onUpdate()"
                        mat-raised-button
                      >
                        Update
                      </button>
                    </div>
                  </mat-grid-tile>
                  <mat-grid-tile *ngIf="screenSize === ScreenType.Mobile">
                    <div class="button-tile">
                      <button mat-dialog-close mat-raised-button>Close</button>
                    </div>
                  </mat-grid-tile>
                </mat-grid-list>
              </div>
            </mat-grid-tile>

            <mat-grid-tile rowspan="5">
              <div class="internalMatGridAssetTable">
                <div class="visitor-image">
                  <img
                    *ngIf="!isPdf"
                    [src]="evidence"
                    alt="No Event Evidence"
                  />
                  <pdf-viewer
                    *ngIf="isPdf"
                    [src]="evidence"
                    [rotation]="0"
                    [original-size]="false"
                    [show-all]="true"
                    [fit-to-page]="false"
                    [zoom]="1"
                    [zoom-scale]="'page-width'"
                    [stick-to-page]="false"
                    [render-text]="true"
                    [external-link-target]="'blank'"
                    [autoresize]="true"
                    [show-borders]="false"
                    style="width: 100%; height: 220px"
                  ></pdf-viewer>
                </div>
                <div
                  class="multiple-evidence-section"
                  *ngIf="isMultipleEvidence"
                >
                  <div class="evidence-header">Uploaded Files</div>
                  <div class="evidence-content-wrapper">
                    <div
                      class="evidence-content"
                      *ngFor="let evidence of complainEvidence; let i = index"
                    >
                      <div class="left-side-content">
                        <b>{{ i + 1 }}.</b> &nbsp;{{
                          evidence.FileName.split(".")[0]
                            | truncateCase
                              : (screenSize == ScreenType.Mobile ? 15 : 30)
                        }}
                      </div>
                      <div class="right-side-content">
                        <button mat-mini-fab (click)="onShowEvidence(evidence)">
                          <mat-icon>touch_app</mat-icon>
                        </button>
                        <button mat-mini-fab (click)="onDownload(evidence)">
                          <mat-icon>file_download</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="multiple-evidence-section"
                  *ngIf="selectedMultipleAttachment?.length > 0"
                >
                  <div class="evidence-header">New Files</div>
                  <div class="evidence-content-wrapper">
                    <div
                      class="evidence-content"
                      *ngFor="
                        let evidence of selectedMultipleAttachment;
                        let i = index
                      "
                    >
                      <div class="left-side-content">
                        <b>{{ i + 1 }}.</b> &nbsp;{{
                          selectedMultipleAttachment[
                            i
                          ].attachedContentName.split(".")[0]
                            | truncateCase
                              : (screenSize == ScreenType.Mobile ? 15 : 30)
                        }}
                      </div>
                      <div class="right-side-content">
                        <button
                          mat-mini-fab
                          (click)="onShowEvidence(evidence, true)"
                        >
                          <mat-icon>touch_app</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="button-tile-onclick-zoom" *ngIf="evidence">
                  <button (click)="onClicktoZoom()" mat-raised-button>
                    Click to Zoom
                  </button>
                </div>
                <div class="button-tile-onclick-zoom" *ngIf="isUpdateIncident">
                  <input
                    type="file"
                    (change)="onFileSelected($event)"
                    accept=".pdf, .jpeg, .png"
                    multiple
                    style="display: none"
                    #fileInput
                  />
                  <button (click)="fileInput.click()" mat-raised-button>
                    Upload Evidence
                  </button>
                </div>
                <div *ngIf="isTimeline" class="button-tile-onclick-zoom">
                  <button (click)="onShowTimeline()" mat-raised-button>
                    <mat-icon *ngIf="!isShowTime">add</mat-icon>
                    <mat-icon *ngIf="isShowTime">remove</mat-icon>
                  </button>
                  <!-- <input [readonly]="true" matInput value="View Timeline" />
                  <button (click)="onShowTimeline()" mat-icon-button matSuffix>
                    <mat-icon>{{ !isShowTime ? "add" : "remove" }}</mat-icon>
                  </button> -->
                </div>
              </div>
            </mat-grid-tile>
          </mat-grid-list>
        </form>
      </mat-card-content>
      <!-- <mat-card-actions></mat-card-actions> -->
    </mat-card>
    <br />
  </div>
</mat-dialog-content>
<!-- OnZoom Dialog Content -->
<ng-template #OnZoomDialog>
  <!-- <h2 matDialogTitle>Please wait!</h2> -->
  <mat-dialog-content>
    <div class="on-zoom-image">
      <div *ngIf="isPdf && !pdfLoaded" class="loading-spinner">
        <mat-spinner></mat-spinner>
      </div>
      <img *ngIf="!isPdf" [src]="evidence" alt="No Event Evidence" />
      <pdf-viewer
        *ngIf="isPdf"
        [src]="evidence"
        [rotation]="0"
        [original-size]="false"
        [show-all]="true"
        [fit-to-page]="true"
        [zoom]="1"
        [zoom-scale]="'page-width'"
        [stick-to-page]="false"
        [render-text]="true"
        [external-link-target]="'blank'"
        [autoresize]="true"
        [show-borders]="false"
        (after-load-complete)="onPdfLoad()"
        style="width: 100%; height: 550px"
      ></pdf-viewer>
    </div>
  </mat-dialog-content>
</ng-template>
<ng-template #OnUpdateAssign>
  <h2 matDialogTitle>Updating Incident</h2>
  <mat-dialog-content
    style="display: flex; justify-content: center; align-items: center"
  >
    <!-- <i> Please wait! Notifying Assignee</i> <br /> -->
    <div class="spinner"><mat-spinner></mat-spinner></div>
  </mat-dialog-content>
</ng-template>
